export const API_BASE_URL = 'https://visitpearl-backend-prod.azurewebsites.net/api';

export const PAGE_SIZE = 10;


